import React, { Component } from 'react'

export class AplicationBtns extends Component {
    render() {
        return (
            <div className='aplication__down'>
                <button className='aplication__btn apple'></button>
                <button className='aplication__btn play'></button>
            </div>
        )
    }
}

export default AplicationBtns